import React from "react";
import ReactDOM from "react-dom/client";
import { SnackbarProvider } from "notistack";
import CssBaseline from "@mui/material/CssBaseline";
import App from "./App";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Theme from "./theme/Theme";
import RTL from "./theme/RTL";
import { RecoilRoot } from "recoil";
import store from "./redux/store";
import { Provider } from "react-redux";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const root = ReactDOM.createRoot(document.getElementById("root"));

const queryClient = new QueryClient();

root.render(
  // <React.StrictMode>
  <>
    <CssBaseline />
    <RTL>
      <RecoilRoot>
        <ThemeProvider theme={Theme}>
          <SnackbarProvider maxSnack={4}>
            <QueryClientProvider client={queryClient}>
              <Provider store={store}>
                <App />
              </Provider>
            </QueryClientProvider>
          </SnackbarProvider>
        </ThemeProvider>
      </RecoilRoot>
    </RTL>
  </>
  // </React.StrictMode>
);
